import React from 'react';
import { NavigationPage } from '../../../../Redux/Reducers/NavigationReducer';
import { CatalogObjectDisplayObject } from '../../../Data/CatalogObjectDisplayObject';
import { DynamicItemComponent } from './Items/DynamicItemComponent';

type HorizontalListComponentParameters = {
  title: string | undefined,
  itemList : Array<CatalogObjectDisplayObject>,
  displayNewPage : (collectionName: string, objectName: string, pageType: string) => void
  noContentText : string | undefined
};

export function HorizontalListComponent(
  {
    title,
    itemList,
    displayNewPage,
    noContentText,
  }: HorizontalListComponentParameters,
) {

  const displayCatalogItem = (
    item : CatalogObjectDisplayObject,
    itemId : number,
  ) => {
    if (item.imageURL && item.imageURL.length > 0) {
      return (
        <DynamicItemComponent
          item={item}
          showPage={displayNewPage}
          pageType={NavigationPage.Object}
          key={itemId}
          noContentText={noContentText}
        />
      );
    }
    return (
      <DynamicItemComponent
        item={item}
        showPage={displayNewPage}
        pageType={NavigationPage.Object}
        key={itemId}
        noContentText={noContentText}
      />
    );

  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <h1>{title}</h1>
        </div>
      </div>
      <div
        className="row list-scrollmenu justify-content-md-center"
        style={{ overflowX: 'auto', justifyContent: 'center' }}
      >
        {itemList.map((item, itemId) => displayCatalogItem(item, itemId))}
      </div>
    </div>
  );

}
